import { ApiClient } from '@provider-portal/common/api';
import { ConfigType } from '@provider-portal/common/config';
import { EventAliasingService } from '@provider-portal/common/services/EventAliasingService';
import { MixpanelService } from '@provider-portal/common/services/MixpanelService';
import { checkProductionMode } from '@provider-portal/common/utils/environment';
import { Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';

import { Bugsnag } from '@bolteu/bugsnag-service-react-web';
import { EpicDependenciesCredentialsVariant } from '@bolteu/redux-session';

import { ApplicationUpdateService } from 'services/ApplicationUpdateService';

export interface AppServices extends EpicDependenciesCredentialsVariant {
  apiClient: ApiClient;
  config: ConfigType;
  // FIXME this should be only web
  bugsnag: Bugsnag.Service;
  mixpanelService: MixpanelService;
  eventAliasingService: EventAliasingService;
  applicationUpdateService: ApplicationUpdateService;
}

const isProductionMode = checkProductionMode();

export const createMiddleware = (middlewareDeps: AppServices) => {
  const logger = createLogger({
    duration: true,
    timestamp: false,
    collapsed(_getState: any, action: any) {
      return !action.reason;
    },
  });

  const epicMiddleware = createEpicMiddleware({
    dependencies: middlewareDeps,
  });

  const allMiddlewares: Middleware[] = [epicMiddleware];
  // Push debugging middlewares
  if (!isProductionMode) {
    allMiddlewares.push(logger);
  }

  return { allMiddlewares, epicMiddleware };
};
